module.exports = __webpack_public_path__ + "static/book@2x-d926af3a2b2827aa1e5be8d62b59797f.jpg";